














































import Vue from 'vue';
// import key from '@/libs/filters/key';
// import util from '@/utils';
import { Component, Prop } from 'vue-property-decorator';
import { getTeachers } from '@/api/educational';
// declare var window: any;
// declare var $: any;
import { getOrgList } from '@/api/school';
import { TOrgList } from '@/types/views/school'

@Component({})
export default class Search extends Vue {
    @Prop({
        type: Function,
        default() {
            return function() {};
        }
    })
    handleOptions!: Function;
    @Prop({
        type: Function,
        default() {
            return function() {};
        }
    })
    getData!: Function;
    @Prop(Boolean) shoulReset!: Boolean;
    // private key: any = key;
    private loading = false;
    // 二次验证
    // private secondary = true;
    private form = {
        orgId: '',
        teacherId: ''
    };
    // add by_ALi
    private orgList = [];
    private teachers: any = {};

    private created() {
        this.getOrgList({orgId: ''});
        this.getTeachers_fun()
    }

    /**
     * 获取校区列表
     * @param {TOrgList} params
     */
    private async getOrgList(params: TOrgList) {
        try {
            let res: any = await getOrgList(params);
            // console.log(res)
            this.orgList = res;
        } catch (e) {
            this.$message.error(e);
        }
    }

    private search() {
        const f = this.form,
            opts = {
                orgId: f.orgId,
                teacherId: f.teacherId
            };
        this.handleOptions(opts);
        this.getData();
    }
    private reset() {
        this.form = {
            orgId: '',
            teacherId: ''
        };
        this.search();
    }

    /**
     * 获取老师列表
     */
    private async getTeachers_fun() {
        try {
        this.teachers = await getTeachers();
        // console.log("----")
        // console.log(this.teachers)
        } catch (e) {
        this.$message.error(e.message);
        }
    }
}
